export default {
	getAll() {
		return [
			{ id: 'USA', name: 'United States' },
			{ id: 'CAN', name: 'Canada' }
		];
	},
};
